import React from 'react';
import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import { LISTBOX_PROPS, UnderTheField } from './autocompleteLook';

import { oblastOptions } from '../oblasts';

// Поле «Область»: выпадающий список из 27 областей с поиском по буквам. Вписать своё написание
// нельзя: в базе должна быть одна запись на одну область.
function OblastSelect({ value, onChange }) {
  return (
    <FormControl fullWidth>
      <Autocomplete
        options={oblastOptions(value)}
        value={value || null}
        onChange={(event, newValue) => onChange(newValue || '')}
        PopperComponent={UnderTheField}
        ListboxProps={LISTBOX_PROPS}
        noOptionsText="Ничего не найдено"
        openText="Открыть список"
        closeText="Закрыть список"
        clearText="Очистить"
        renderInput={(params) => <TextField {...params} label="Область" variant="outlined" />}
      />
    </FormControl>
  );
}

export default OblastSelect;
